// extracted by mini-css-extract-plugin
export default {"modal":"SubscribeModal-module__modal"};